<template>
  <div
    slot="content"
    class="vendor-status-list"
  >
    <table>
      <thead>
        <th>{{ $t('vendor.invitedVendors') }}</th>
        <th>{{ $t('vendor.onSiteVisitDateTime') }}</th>
        <th>{{ $t('vendor.status') }}</th>
        <th>{{ $t('handover.lastUpdateOn') }}</th>
      </thead>
      <tbody>
        <tr
          v-for="(bid) in formattedBids"
          :key="bid.id"
        >
          <td class="vendor-name">
            {{ bid.companyName }}
          </td>
          <td class="visit-date row">
            {{ bid.visitDate }}
          </td>
          <td class="vendor-status">
            {{ bid.status }}
          </td>
          <td class="vendor-respond-date">
            <span v-if="bid.lastSubmittedOn">{{ bid.lastSubmittedOn }}</span>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="status-summary">
      <label>SUBMITTED:</label>
      <span>{{ totalSubmittedbids }}</span>
    </div>
  </div>
</template>

<script>
import lodash from 'lodash'
import { defineComponent } from '@vue/composition-api'
import { unref, computed } from 'vue-demi'
import { useStoreGetters } from '@/store'
import { sortBids } from '@/utils/sortingHelper'
import dateUtil from '@/utils/dateUtil'
import { vendorBidStatus, bidStatusMapHealthCheck } from '@/utils/locale'

export default defineComponent({
  setup (props) {
    const { currentTender } = useStoreGetters('tenders', ['currentTender'])

    const getLastSubmittedOn = (bid) => {
      if (bid.respondedOn || bid.startBidAt) {
        const updatedOn = bid.respondedOn || bid.startBidAt
        const date = dateUtil.formatDate(updatedOn, true, true)
        return date
      }
      return ''
    }
    const formattedBids = computed(() => {
      const orderedBids = sortBids(unref(currentTender).bids)
      const bids = orderedBids.map(bid => {
        const lastSubmittedOn = getLastSubmittedOn(bid)
        const visitDate = bid.visitDate ? dateUtil.format(bid.visitDate, 'DD MMM YY HH:mm') : ''
        return {
          id: bid.id,
          companyName: lodash.get(bid, 'company.name', ''),
          status: bidStatusMapHealthCheck[bid.status] || null,
          originStatus: bid.status,
          lastSubmittedOn,
          visitDate,
        }
      })
      return bids
    })
    const totalSubmittedbids = computed(() => {
      let submittedBids = unref(formattedBids).filter((bid) => {
        return bid.originStatus === vendorBidStatus.SUBMITTED
      })
      return submittedBids.length
    })
    return {
      formattedBids,
      totalSubmittedbids,
    }
  },
})
</script>

<style lang="scss" scoped>
@import '~styles/table';
$healthcheck-font-color: #0C3A58;
.vendor-status-list {
  color: $healthcheck-font-color;
}
label {
  margin: 0;
}
.label-bold {
  margin: 0 0;
  font-weight: bold;
}

.vendor-name {
  width: 50%;
  min-width: 350px;
  word-wrap: break-word;
}
.visit-date {
  min-height: 40px;
  word-wrap: break-word;
  display: table-cell;
}
.vendor-status {
  width: 20%;
  min-width: 100px;
  span{
    display: inline-block;
  }
}

#view-closing-date-onsite-visit-required {
  vertical-align: middle;
}

.status-summary {
  text-align: right;
  label {
    display: inline-block;
    font-weight: bold;
    color: $healthcheck-font-color;
  }
  span {
    padding-right: 10px;
  }
}
</style>
